import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";

import classNames from "classnames";
import BetDetailsStore from "@state/stores/my-bets/BetDetailsStore";
import { Button } from "@components/buttons";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import { CashoutLocation } from "@utils/common/cashoutLocation";
import { OpenCashoutModalType } from "@data-types/my-bets/OpenCashoutModal";
import { BetSlipShareDetails } from "@state/stores/my-bets/BetSlipShareDetailsStore";

export default observer(function CashoutConfirmationForm(props: {
	store: MyBetsStore | BetDetailsStore | BetSlipShareDetails;
}) {
	const { t } = useTranslation();

	const methods = useForm();

	const { register, handleSubmit } = methods;

	const onSubmit = (data: OpenCashoutModalType) => {
		if (props.store.cashoutStore.cashoutModalData) {
			props.store.cashoutStore.cashout(
				{
					id: props.store.cashoutStore.cashoutModalData?.id,
					calculatedCashoutAmount:
						props.store.cashoutStore.cashoutModalData
							?.calculatedCashoutAmount,
					displayedAmount:
						props.store.cashoutStore.cashoutModalData
							.displayedAmount,
					userId: props.store.cashoutStore.cashoutModalData.userId,
					cType: props.store.cashoutStore.cashoutModalData?.cType,
					isLive: props.store.cashoutStore.cashoutModalData?.isLive,
					isChangeAccepted: data.isChangeAccepted || false,
					liveBetSlipCountdown:
						props.store.cashoutStore.cashoutModalData
							?.liveBetSlipCountdown,
				},
				CashoutLocation.MY_BETS
			);
		}
	};

	const betActionsClass = classNames({
		"bet--mini__actions__col col col-sml-6":
			!WEBPACK_IS_AUTOCASHOUT_ENABLED,
		"bet--mini__actions__col": WEBPACK_IS_AUTOCASHOUT_ENABLED,
	});

	const checkFieldClasses = classNames("input--check u-mar--y--xsml");

	return (
		<FormProvider {...methods}>
			<form
				onSubmit={handleSubmit(onSubmit)}
				id="cashout-form"
				className={betActionsClass}
			>
				<Button
					className="bet__btn btn btn--wrap btn--wrap--med btn--block btn--success btn--icon"
					type="submit"
					btnContent={
						<>
							<i className="u-icon u-icon--sml u-icon--check u-color--core--snow"></i>
							<span>{t<string>("mybets:ITEM.CASHOUT")}</span>
						</>
					}
					disabled={props.store.cashoutStore.isLoading}
				></Button>
				<button
					className="bet__btn btn btn--wrap btn--wrap--med btn--block btn--primary--inverted btn--icon u-color--sent--danger"
					type="button"
					onClick={props.store.cashoutStore.closeCashoutModal}
				>
					<i className="u-icon u-icon--sml u-icon--remove u-color--sent--danger" />
					<span>{t<string>("COMMON.CANCEL")}</span>
				</button>

				<div className={checkFieldClasses}>
					<input
						id="isChangeAccepted"
						className="input--check__box"
						type="checkbox"
						{...register("isChangeAccepted")}
					/>
					<label
						htmlFor="isChangeAccepted"
						className="input--check__label u-type--wgt--regular"
					>
						{t<string>("mybets:CASHOUT.ACCEPT_CHANGED_AMOUNT")}
					</label>
				</div>
			</form>
		</FormProvider>
	);
});
